import { defineNuxtRouteMiddleware } from 'nuxt/app'

import { isCPAuthRoutePath } from '../utils/auth-route.utils'
import { isCrossingCommunitiesGroupsUsersLayout } from '../utils/communities-layout-route.utils'

/**
 * Auth routes own a full-screen layout. Disable transitions at this boundary so
 * Nuxt does not retain the previous layout wrapper while auth content enters.
 *
 * Communities group ↔ user profile layouts swap wrappers. Disable transitions at
 * that boundary so out-in layout leave does not strand the old layout in
 * layout-leave-active while the URL already points at the target.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const isEnteringOrLeavingAuth = isCPAuthRoutePath(to.path) !== isCPAuthRoutePath(from.path)
  const isCrossingCommunitiesProfileLayout = isCrossingCommunitiesGroupsUsersLayout(from.path, to.path)

  if (isEnteringOrLeavingAuth || isCrossingCommunitiesProfileLayout) {
    to.meta.layoutTransition = false
    to.meta.pageTransition = false
  }
})
